import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CheckoutError, CheckoutState, TicketPurchase } from "./types";

const initialState: CheckoutState = {
    loading: false,
    error: CheckoutError.NONE,
    checkoutOpen: false,
    ticketPurchases: new Map<number, number>()
}

export const checkoutSlice = createSlice({
    name: 'checkout',
    initialState,
    reducers: {
        loading: (state) => { state.loading = true },
        fetched: (state) => { state.loading = false },
        clear: (state) => { state = initialState },
        openCheckout: (state) => { state.checkoutOpen = true},
        closeCheckout: (state) => { state.checkoutOpen = false},
        addTicketPurchase: (state, action: PayloadAction<TicketPurchase>) => { 
            if(state.ticketPurchases.has(action.payload.ticketId)) {
                const currentQuantity = state.ticketPurchases.get(action.payload.ticketId)!;
                state.ticketPurchases.set(action.payload.ticketId, currentQuantity + action.payload.quantity);
            } else {
                state.ticketPurchases.set(action.payload.ticketId, action.payload.quantity);
            }
        },
        removeTicketPurchase: (state, action: PayloadAction<TicketPurchase>) => { 
            if(state.ticketPurchases.has(action.payload.ticketId)) {
                const currentQuantity = state.ticketPurchases.get(action.payload.ticketId)!;

                if(action.payload.quantity >= currentQuantity)
                    state.ticketPurchases.delete(action.payload.ticketId);
                else
                    state.ticketPurchases.set(action.payload.ticketId, currentQuantity - action.payload.quantity);
            }
        }
    },
})

// Selectors
export const selectTicketPurchases = (state: CheckoutState) => state.ticketPurchases;
export const selectCheckoutOpen = (state: CheckoutState) => state.checkoutOpen;
export const selectCheckoutError = (state: CheckoutState) => state.error;
export const selectCheckoutLoadingStatus = (state: CheckoutState) => state.loading;

export const { 
    clear,
    loading,
    fetched,
    openCheckout,
    closeCheckout
} = checkoutSlice.actions;

export default checkoutSlice.reducer